import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { getLegalPolicy, getPrivacyPolicy, getTermAndCondition } from '../../Services/PagesServices'
const useWebPages = () => {


    const [termAndCondition, setTermAndCondition] = useState(null)
    const [privacyPolicy, setPrivacyPolicy] = useState(null)
    const [legalPolicy, setLegalPolicy] = useState(null)
    const [isLoading, setIsLoading] = useState(false)


    const handleTermAndCondition = async () => {
        setIsLoading(true)
        let response = await getTermAndCondition()
        if (response.statusCode === 200) {
            setTermAndCondition(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handlePrivacyPolicy = async () => {
        setIsLoading(true)
        let response = await getPrivacyPolicy()
        if (response.statusCode === 200) {
            setPrivacyPolicy(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleLegalPolicy = async () => {
        setIsLoading(true)
        let response = await getLegalPolicy()
        if (response.statusCode === 200) {
            setLegalPolicy(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        handleTermAndCondition()
    }, [])

    useEffect(() => {
        handleLegalPolicy()
    }, [])

    useEffect(() => {
        handlePrivacyPolicy()
    }, [])

    return [
        termAndCondition,
        legalPolicy,
        isLoading,
        privacyPolicy
    ]
}

export default useWebPages